import type { FaireProductEntity } from "../../entity_types/product";

export const p_29v63xzs7f: FaireProductEntity = {
  token: "p_29v63xzs7f",
  type: "product",
  name: "Lymphatic drainage face brush & fountain of youth serum set",
  brandToken: "b_m3n7j6u3h2",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/02dea958cd206fb593ead78aa505ea3e062d5b2365c922301c9eb91d74f4cea9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/10cb0804bee4314248b4aa41b0bd37a76329dc972f370f3795aced6f96240d97.png",
    "https://cdn.faire.com/fastly/821bededdb6fd08c007effa2607afdec766789f290c81c4b68265b2d377b0ca1.png",
  ],
  priceDollars: 35.34,
  description:
    'Lymphatic drainage face dry brush and face serum set. These make great wellness gifts!\n\nIncluded: 15 ML amber glass dropper bottle of our "ritual" ancient beauty elixir\nLymphatic drainage dry brush with hard case\nCotton drawstring pouch\n\nIngredients: Rosehip oil*,Golden jojoba oil*,Castor oil*,Black seed oil*, Frankincense resin* Myrrh resin*,Vitamin E   *=Certified organic \n\nOur ancient beauty elixir is simple yet powerful. We use the same ingredients that Cleopatra once used on her skin. First, we grind organic frankincense and myrrh resins down to a fine powder. Then, we infuse the resins in a luscious combination of oils and let it sit in the sun for a minimum of 5 weeks for max potency. Our elixir is the perfect follow up to dry brushing with our soft bristled face brush. Comes with a cotton drawstring pouch for gifting or easy transporting. \n\nNO TOXINS\nNON GMO\nMADE IN THE USA\nWOMEN/MOM OWNED BUSINESS',
  tags: [],
  msrpDollars: 70.67,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:14.520Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
